<template>
  <div class="ui left aligned container">
    <vuetable ref="vuetable"
              api-url="/douyin/"
              :fields="fields"
              :sort-order="sortOrder"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    <div class="links">
      <a href="https://v.douyin.com/JcmxqC9/" target="_blank">主页</a>
      <a href="https://v.douyin.com/J3H5pSN/" target="_blank">频道</a>
    </div>

    <div class="ui hidden divider"></div>
    <div class="row">
      <date-picker range valueType="format" @clear="range=[]" v-model="range"></date-picker>
      <button class="ui load button" @click="load">Load</button>
    </div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style>
.ui.load.button {
  margin-left: 12px;
}
.links a {
  margin-right: 12px;
}
</style>
<script>
  import Vuetable from '../table/Vuetable.vue'
  import VuetablePagination from '../table/VuetablePagination.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'Douyin',
    components: {
      Vuetable,
      VuetablePagination,
      DatePicker,
      'v-chart': ECharts
    },
    data () {
      return {
        fields: [
          {name: 'date', title: '日期', sortField: 'date'},
          {name: 'awemeCount', title: '作品'},
          // {name: 'favoritingCount', title: '喜欢的作品'},
          // {name: 'followingCount', title: '关注'},
          {name: 'followerCount', title: '粉丝', callback: 'count'},
          {name: 'totalFavorited', title: '点赞', callback: 'count'},
          {name: 'userCount', title: '频道视频'},
          {name: 'viewCount', title: '频道播放', callback: 'count'},
        ],
        page: 0,
        range: [],
        options: null,
        sortOrder: [
          {
            field: 'date',
            direction: 'desc'
          }
        ]
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        if (page === 'prev') {
          this.page--
        } else if (page === 'next') {
          this.page++
        } else {
          this.page = parseInt(page)
        }
        this.range = [];
        this.load();
        this.$refs.vuetable.changePage(page)
      },
      load: function () {
        let api = `/douyin/chart?size=10&page=${this.page}`
        if (this.range.length === 2) {
          api = `/douyin/chart?start=${this.range[0]}&end=${this.range[1]}`
        }
        axios.get(api).then(response => {
          this.options =
              {
                title: {
                  text: '增幅'
                },
                tooltip: {
                  trigger: 'axis'
                },
                legend: {
                  data: ['作品', '粉丝', '点赞', '频道播放']
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                xAxis: {
                  type: 'time'
                },
                yAxis: {
                  type: 'value'
                },
                series: [
                  {
                    name: '作品',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.awemeCount])
                  },
                  {
                    name: '粉丝',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.followerCount])
                  },
                  {
                    name: '点赞',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.totalFavorited])
                  },
                  {
                    name: '频道播放',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.viewCount])
                  },
                ]
              };
        });
      },
      count(value) {
        if (value >= 1e8) {
          return (value / 1e8).toFixed(2) + '亿'
        } else if (value >= 1e4) {
          return (value / 1e4).toFixed(2) + '万'
        } else {
          return value + ''
        }
      },
    }
  }
</script>
